import React from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

import { RootState } from '@debbie/cortex/dist/reducer.js'
import { selectUsersOnCase } from '@debbie/cortex/dist/users/selectors.js'
import { MenuItem, UserPreview } from '@debbie/iris/dist/components/index.js'

const ActiveUsersOnCase = (props: { id: string }) => {
  const usersOnCase = useSelector((s: RootState) =>
    selectUsersOnCase(s, props.id),
  )

  const filteredUsersOnCase =
    usersOnCase && usersOnCase.filter((user) => !user.details.isSystemAgent)

  return filteredUsersOnCase && filteredUsersOnCase.length > 0 ? (
    <MenuItem>
      <div>
        {filteredUsersOnCase.map((user) => (
          <ActiveUser key={user.id}>
            <UserPreview
              user={{
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName,
                role: user.role,
              }}
            />
          </ActiveUser>
        ))}
      </div>
    </MenuItem>
  ) : null
}

export default ActiveUsersOnCase

const ActiveUser = styled.div`
  display: inline-block;
  position: relative;

  .active-user-tooltips {
    position: absolute;
    bottom: 21px;
    left: -5px;
    min-width: 100px;

    .typing-indicator {
      margin-top: 5px;
    }

    .case-preview {
      margin-top: 5px;
      font-size: 0.5em;
    }
  }
`
